"use client";

import React from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
interface Distributor {
  id: string;
  name: string;
  city: string;
  address: string;
  phone: string;
  phone2?: string;
  // 改為儲存地圖精準搜尋關鍵字
  mapSearchQuery: string;
}
export default function FindTheFlavor() {
  // 經銷點資料，已優化定位關鍵字（合併店名與地址，可提供最精確的圖針定位）
  const distributors: Distributor[] = [{
    id: "qian-hui",
    name: "千輝經銷點",
    city: "高雄市",
    address: "高雄市三民區中華二路339號",
    phone: "07-5521675",
    mapSearchQuery: "特恩地板 高雄市三民區中華二路339號"
  }, {
    id: "qi-wei",
    name: "琦瑋經銷點",
    city: "高雄市",
    address: "高雄市鳳山區頂庄路191號",
    phone: "07-7920191",
    mapSearchQuery: "琦暐地板 高雄市鳳山區頂庄路191號"
  }, {
    id: "taichung",
    name: "台中經銷點",
    city: "台中市",
    address: "台中市北屯區太原路三段850號",
    phone: "04-24351077",
    phone2: "0976-807910",
    mapSearchQuery: "特恩地板 台中市北屯區太原路三段850號"
  }];

  // 台南總部地圖搜尋參數與跳轉連結
  const tainanQuery = encodeURIComponent("Hent's亨特地板 台南市安平區府平路472號");
  const tainanMapUrl = `https://www.google.com/maps/search/?api=1&query=${tainanQuery}`;
  const tainanEmbedUrl = `https://www.google.com/maps/embed/v1/place?key=YOUR_GOOGLE_MAPS_API_KEY&q=${tainanQuery}`;
  return <section data-section-id="89177" id="聯絡資訊-contact-info" className="w-full py-24 px-6 md:px-12 lg:px-24 select-none">
      <div className="max-w-6xl mx-auto">
        
        {/* ==========================================
             頂部加開：台南總部展示中心區塊
           ========================================== */}
    {/* ==========================================
             頂部：台南總部展示中心區塊（已優化對齊與高度）
           ========================================== */}
        {/* 加上 items-stretch，確保左右兩欄在 lg 螢幕以上時等高，達成頂部與底部同時對齊 */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-stretch border-b border-[#d3bfae]/30 pb-20 mb-24">
          
          {/* 左側：門市外觀圖片（寬度填滿，高度與右側完全等高對齊） */}
          {/* 移除 aspect 比例限制，改用 h-full 填滿，在 md 以下則給予 min-h 維持高度 */}
          <div className="lg:col-span-6 w-full h-full min-h-[380px] md:min-h-[480px] rounded-2xl overflow-hidden shadow-sm relative group">
            <img src="https://hent.services/wp-content/uploads/2026/05/Contact-BG.webp" alt="Hent's 亨特地板台南展示中心" className="h-full w-full object-cover transition-transform duration-[2000ms] ease-out group-hover:scale-102 pointer-events-none" />
            <div className="absolute inset-0 bg-white/[0.01]" />
          </div>

          {/* 右側：精品人文聯絡與營業時間面板 */}
          {/* flex flex-col justify-between 可以讓按鈕自然貼齊底部，更具設計感 */}
          <div className="lg:col-span-6 flex flex-col justify-between items-start text-left text-[#9c8d83] py-1">
            
            <div className="w-full">
              <div className="space-y-1 mb-8">
                <h2 className="font-sans text-xl md:text-2xl font-semibold tracking-wider text-[#9c8d83]">
                  Hent's 亨特地板 | 台南展示中心
                </h2>
              </div>

              <div className="space-y-4 w-full border-b border-[#d3bfae]/20 pb-6 mb-6">
                <div className="flex items-center gap-4 text-[15px] font-hk-light tracking-widest text-[#3d3d3d]">
                  <MapPin className="size-4.5 text-[#9c8d83] shrink-0" strokeWidth={1.5} />
                  <span>台南市安平區府平路472號</span>
                </div>
                <div className="flex items-center gap-4 text-[15px] font-sans tracking-wider text-[#3d3d3d]">
                  <Phone className="size-4.5 text-[#9c8d83] shrink-0" strokeWidth={1.5} />
                  <span>06-2984755</span>
                </div>
                <div className="flex items-center gap-4 text-[15px] font-sans tracking-wide text-[#3d3d3d]">
                  <Mail className="size-4.5 text-[#9c8d83] shrink-0" strokeWidth={1.5} />
                  <span>hents.flooring@gmail.com</span>
                </div>
              </div>

              <div className="flex items-start gap-4 w-full mb-8 lg:mb-0">
                <div className="h-16 w-[1.5px] bg-[#9c8d83]/50 shrink-0 mt-1" />
                <div className="space-y-1.5 font-hk-light text-sm md:text-[15px] tracking-widest text-[#3d3d3d]/90">
                  <div className="grid grid-cols-4 gap-x-4">
                    <span className="text-[#9c8d83]">週一 ~ 週五</span>
                    <span className="col-span-3 font-sans">09:00 ~ 18:00</span>
                  </div>
                  <div className="grid grid-cols-4 gap-x-4">
                    <span className="text-[#9c8d83]">週六</span>
                    <span className="col-span-3 font-sans">10:00 ~ 19:00</span>
                  </div>
                  <div className="grid grid-cols-4 gap-x-4">
                    <span className="text-[#9c8d83]">週日</span>
                    <span className="col-span-3 text-[#9c8d83]/70">門市休息</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 按鈕區塊 */}
            <div className="flex flex-wrap gap-4 w-full mt-8">
              <Button asChild className="h-10 rounded-md px-6 text-xs font-medium tracking-widest bg-[#9c8d83] hover:bg-[#86776d] text-white shadow-sm cursor-pointer flex items-center gap-2 border-none">
                <Link to={tainanMapUrl} newTab>
                  <MapPin className="size-3.5" strokeWidth={1.8} /> 查看地圖
                </Link>
              </Button>

              <Button asChild className="h-10 rounded-md px-6 text-xs font-medium tracking-widest bg-[#9c8d83] hover:bg-[#86776d] text-white shadow-sm cursor-pointer flex items-center gap-2 border-none">
                <Link to="#contact-form">
                  <Mail className="size-3.5" strokeWidth={1.8} /> 預約參觀
                </Link>
              </Button>
            </div>

          </div>
        </div>

        {/* ==========================================
            2. 中段：全台各地區經銷商標題
           ========================================== */}
        <div className="mb-20 text-center flex flex-col items-center">
          <div className="flex items-center justify-center gap-3 mb-3 text-center">
            <span className="font-sans text-xs font-light text-[#d3bfae]">/</span>
            <span className="font-sans text-[11px] font-semibold tracking-[0.2em] text-[#d3bfae] uppercase">
              DISTRIBUTORS
            </span>
            <span className="font-sans text-xs font-light text-[#d3bfae]">/</span>
          </div>

          <div className="relative inline-block px-2">
            <h2 className="relative z-10 font-hk-regular text-2xl md:text-3xl font-bold tracking-widest text-[#604f45] flex items-center gap-3">
              <span className="text-[#a98e70] font-light">|</span> 全台各地區經銷 <span className="text-[#a98e70] font-light">|</span>
            </h2>
          </div>
        </div>

        {/* ==========================================
            3. 下方：三欄經銷商卡片區
           ========================================== */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12 items-start">
          {distributors.map(item => {
          const encodedQuery = encodeURIComponent(item.mapSearchQuery);
          // 點擊按鈕跳轉的 Google 地圖官方 URL
          const googleMapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedQuery}`;
          return <div key={item.id} className="flex flex-col items-center text-center group w-full">
                
                {/* 【核心修正】圖片區塊直接替換為帶有真實定位紅針的互動式 Google 地圖 */}
                <div className="w-full aspect-[16/10] rounded-lg overflow-hidden border border-[#d3bfae]/40 shadow-sm relative mb-6">
                  <iframe src={`https://maps.google.com/maps?q=${encodedQuery}&t=&z=15&ie=UTF8&iwloc=&output=embed`} className="w-full h-full border-0" allowFullScreen loading="lazy" />
                </div>

                <h3 className="font-hk-regular text-lg font-semibold tracking-widest text-[#604f45] mb-2">
                  {item.name}
                </h3>

                <div className="flex flex-col gap-1.5 items-center mb-6 min-h-[70px]">
                  <p className="font-hk-light text-sm tracking-wide text-[#3d3d3d]/90">
                    {item.address}
                  </p>
                  <p className="font-sans text-sm tracking-wider text-[#3d3d3d]/80">
                    {item.phone} 
                    {item.phone2 && <span className="mx-1.5 text-[#d3bfae]">|</span>}
                    {item.phone2 && <span>{item.phone2}</span>}
                  </p>
                </div>

                <div className="flex flex-col gap-3 w-[160px]">
                  <Button asChild className="h-9 rounded-md text-xs tracking-widest bg-[#8c7e74] hover:bg-[#76695f] text-white shadow-sm cursor-pointer flex items-center justify-center gap-1.5 border-none">
                    <Link to={googleMapUrl} newTab>
                      <MapPin className="size-3.5" /> 查看地圖
                    </Link>
                  </Button>

              <Button asChild className="h-9 rounded-md text-xs tracking-widest bg-[#9c8d83] hover:bg-[#86776d] text-white shadow-sm cursor-pointer flex items-center justify-center gap-1.5 border-none">

  <a href="#contact-form">
    <Mail className="size-3.5" /> 
    <span>預約參觀</span>
  </a>
</Button>
                </div>

              </div>;
        })}
        </div>

      </div>
    </section>;
}